// Announcement Bar JS: Handles switching between announcement blocks and updates bar styles

document.addEventListener('DOMContentLoaded', function() {
  const bar = document.querySelector('.announcement-bar');
  if (!bar) return;

  // Marquee mode detection
  const isMarquee = bar.querySelector('.announcement-bar__blocks--marquee');
  if (isMarquee) {
    // Marquee logic: duplicate content for seamless scroll if needed
    const track = bar.querySelector('.announcement-bar__marquee-track');
    if (track && track.children.length > 0) {
      // Duplicate the blocks for seamless looping
      track.innerHTML += track.innerHTML;
      // Set initial bar color to first block
      const firstBlock = track.querySelector('.announcement-bar__block--marquee');
      if (firstBlock) {
        const bg = firstBlock.getAttribute('data-bg');
        const color = firstBlock.getAttribute('data-color');
        bar.style.backgroundColor = bg;
        bar.style.color = color;
        bar.style.setProperty('--background-color', bg);
        bar.style.setProperty('--text-color', color);
      }
    }
    return; // Skip all other logic in marquee mode
  }
  
  const blocks = Array.from(bar.querySelectorAll('.announcement-bar__block'));
  if (blocks.length === 0) return;

  let activeIndex = 0;
  // Get transition effect from data attribute (set in Liquid)
  const transitionEffect = bar.dataset.transitionEffect || 'fade';

  // Helper to remove all transition classes
  function clearTransitionClasses(block) {
    block.classList.remove('is-fading', 'is-sliding-vertical', 'is-sliding-horizontal', 'is-active');
  }

  function setActiveBlock(index) {
    blocks.forEach((block, i) => {
      clearTransitionClasses(block);
      if (i === index) {
        // Update bar background and text color using CSS variables for full inheritance
        const bg = block.getAttribute('data-bg');
        const color = block.getAttribute('data-color');
        bar.style.backgroundColor = bg;
        bar.style.color = color;
        bar.style.setProperty('--background-color', bg);
        bar.style.setProperty('--text-color', color);

        // Always make block visible before animating
        block.style.display = '';
        // Force reflow to allow animation to trigger
        void block.offsetWidth;

        // Transition logic
        if (transitionEffect === 'fade') {
          block.classList.add('is-fading', 'is-active');
        } else if (transitionEffect === 'vertical_slide') {
          block.classList.add('is-sliding-vertical', 'is-active');
        } else if (transitionEffect === 'horizontal_slide') {
          block.classList.add('is-sliding-horizontal', 'is-active');
        } else {
          block.classList.add('is-active');
        }

        // Remove animation class after animation ends to allow re-trigger
        block.addEventListener('animationend', function handler(e) {
          if (
            (transitionEffect === 'vertical_slide' && e.animationName === 'slideInBarVertical') ||
            (transitionEffect === 'horizontal_slide' && e.animationName === 'slideInBarHorizontal') ||
            (transitionEffect === 'fade' && e.animationName === 'fadeInBar')
          ) {
            block.classList.remove('is-sliding-vertical', 'is-sliding-horizontal', 'is-fading');
            block.removeEventListener('animationend', handler);
          }
        });
      } else {
        block.style.display = 'none';
      }
    });
    activeIndex = index;
    updateDots();
  }

  // Navigation: Dots
  const dots = Array.from(bar.querySelectorAll('.announcement-bar__nav-dot'));
  function updateDots() {
    dots.forEach((dot, i) => {
      // Remove all icons
      dot.innerHTML = '';
      if (i === activeIndex) {
        dot.classList.add('active');
        dot.setAttribute('aria-current', 'true');
        // Active dot: filled circle
        dot.innerHTML = '<i class="bi bi-circle-fill"></i>';
      } else {
        dot.classList.remove('active');
        dot.removeAttribute('aria-current');
        // Inactive dot: empty circle
        dot.innerHTML = '<i class="bi bi-circle"></i>';
      }
    });
  }
  dots.forEach((dot, i) => {
    dot.addEventListener('click', function() {
      setActiveBlock(i);
    });
  });

  // Navigation: Chevrons
  const prevBtn = bar.querySelector('.announcement-bar__nav-chevron--prev');
  const nextBtn = bar.querySelector('.announcement-bar__nav-chevron--next');
  if (prevBtn && nextBtn) {
    prevBtn.addEventListener('click', function() {
      setActiveBlock((activeIndex - 1 + blocks.length) % blocks.length);
    });
    nextBtn.addEventListener('click', function() {
      setActiveBlock((activeIndex + 1) % blocks.length);
    });
  }

  // Optionally: Autoscroll
  const autoscroll = bar.dataset.autoscroll === 'true';
  const interval = parseInt(bar.dataset.autoscrollInterval, 10) || 5000;
  let timer = null;
  if (autoscroll && blocks.length > 1) {
    timer = setInterval(() => {
      setActiveBlock((activeIndex + 1) % blocks.length);
    }, interval);
    // Pause on hover
    if (bar.dataset.pauseOnHover === 'true') {
      bar.addEventListener('mouseenter', () => clearInterval(timer));
      bar.addEventListener('mouseleave', () => {
        timer = setInterval(() => {
          setActiveBlock((activeIndex + 1) % blocks.length);
        }, interval);
      });
    }
  }

  setActiveBlock(0);
});
